<template>
    <div>
      <div class="ds-header">
        <div class="ds-title">
          Configurações Gerais
        </div>
      </div>

        <div class="card p-3">
            <div class="card-title">Configurações do módulo estoque</div>
            <div class="option">
            <toggle-button :disabled="!canEditModule" class="togle-button" v-model="form.autocomplete_purchase_price" :sync="true" :height="32" :color="{checked: '#00C773', unchecked: '#E1E5F4'}" @change="(el) => updateWarehouseConfigurations({ autocomplete_purchase_price: el.value })" />
            Preencher automaticamente custos de item e valor ao efetuar saída
            </div>
            <div class="option">
            <toggle-button :disabled="!canEditModule" class="togle-button" v-model="form.entries_outputs_editable" :sync="true" :height="32" :color="{checked: '#00C773', unchecked: '#E1E5F4'}" @change="(el) => updateWarehouseConfigurations({ entries_outputs_editable: el.value })" />
                Permitir edição de saídas e entradas efetuadas
            </div>
            <div class="option">
                <toggle-button :disabled="!canEditModule" class="togle-button" v-model="form.provider_required" :sync="true" :height="32" :color="{checked: '#00C773', unchecked: '#E1E5F4'}" @change="(el) => updateWarehouseConfigurations({ provider_required: el.value })" />
                Preenchimento de fornecedores obrigatório para todos os produtos
            </div>
            <div class="option">
                <toggle-button :disabled="!canEditModule" class="togle-button" v-model="form.entry_blocked_in_central_inventory" :sync="true" :height="32" :color="{checked: '#00C773', unchecked: '#E1E5F4'}" @change="(el) => updateWarehouseConfigurations({ entry_blocked_in_central_inventory: el.value })" />
                Todas as entradas de produtos devem, por padrão, ser registradas no estoque central.
            </div>
            <div class="option">
                <toggle-button :disabled="!canEditModule" class="togle-button" v-model="form.return_blocked_in_central_inventory" :sync="true" :height="32" :color="{checked: '#00C773', unchecked: '#E1E5F4'}" @change="(el) => updateWarehouseConfigurations({ return_blocked_in_central_inventory: el.value })" />
                Todas as entradas de produtos decorrentes de devoluções devem, por padrão, ser registradas no estoque central.
            </div>
            <div class="option">
                <toggle-button :disabled="!canEditModule" class="togle-button" v-model="form.update_cost_last_receipt" :sync="true" :height="32" :color="{checked: '#00C773', unchecked: '#E1E5F4'}" @change="(el) => updateCostConfiguration({ update_cost_last_receipt: el.value })" />
                Atualizar preço de custo do produto conforme a última movimentação.
            </div>
            <div class="option">
                <toggle-button :disabled="!canEditModule" class="togle-button" v-model="form.update_cost_if_greater" :sync="true" :height="32" :color="{checked: '#00C773', unchecked: '#E1E5F4'}" @change="(el) => updateCostConfiguration({ update_cost_if_greater: el.value }) " />
                Atualizar preço de custo na entrada/saída do produto se o novo custo for maior.
            </div>
            <div class="option">
                <toggle-button :disabled="!canEditModule" class="togle-button" v-model="form.update_sale_price_last_receipt" :sync="true" :height="32" :color="{checked: '#00C773', unchecked: '#E1E5F4'}" @change="(el) => updateSalePriceConfiguration({ update_sale_price_last_receipt: el.value })" />
                Atualizar preço de venda do produto conforme a última movimentação
            </div>
            <div class="option">
                <toggle-button :disabled="!canEditModule" class="togle-button" v-model="form.update_sale_price_if_greater" :sync="true" :height="32" :color="{checked: '#00C773', unchecked: '#E1E5F4'}" @change="(el) => updateSalePriceConfiguration({ update_sale_price_if_greater: el.value }) " />
                Atualizar preço de venda na entrada/saída do produto se o preço for maior.
            </div>
            <!-- <div class="option">
                <toggle-button class="togle-button" v-model="form.batch_control_required" :sync="true" :height="32" :color="{checked: '#00C773', unchecked: '#E1E5F4'}" @change="(el) => updateWarehouseConfigurations({ batch_control_required: el.value })" />
                Controle de lotes obrigatório para todos os produtos
            </div> -->
        </div>
        <div class="card p-3">
            <div class="card-title">Configurações de aviso</div>
            <div class="option">
                <toggle-button :disabled="!canEditPreferences" class="togle-button" v-model="form.notify_low_stock" :sync="true" :height="32" :color="{checked: '#00C773', unchecked: '#E1E5F4'}" @change="(el) => updateWarehouseConfigurations({ notify_low_stock: el.value })" />
                Permitir avisos do sistema para produtos abaixo da quantidade mínima
            </div>
            <div class="option">
                <toggle-button :disabled="!canEditPreferences" class="togle-button" v-model="form.notify_near_expiring" :sync="true" :height="32" :color="{checked: '#00C773', unchecked: '#E1E5F4'}" @change="(el) => updateWarehouseConfigurations({ notify_near_expiring: el.value })" />
                Permitir avisos do sistema para produtos com vencimento próximo
            </div>
            <div class="option">
                <toggle-button :disabled="!canEditPreferences" class="togle-button" v-model="form.notify_expired_date" :sync="true" :height="32" :color="{checked: '#00C773', unchecked: '#E1E5F4'}" @change="(el) => updateWarehouseConfigurations({ notify_expired_date: el.value })" />
                Permitir avisos do sistema para produtos vencidos
            </div>
            <div class="option">
                <toggle-button :disabled="!canEditPreferences" class="togle-button" v-model="form.notify_return_enabled" :sync="true" :height="32" :color="{checked: '#00C773', unchecked: '#E1E5F4'}" @change="(el) => updateWarehouseConfigurations({ notify_return_enabled: el.value })" />
                Permitir notificações do sistema para lembrete de devolução.
            </div>
        </div>
    </div>
</template>
<script>
import { userHasPermission, getCurrentClinic } from '@/utils/localStorageManager'
export default {
  components: {
    // 
  },
  mounted() {
    this.getWarehouseConfigurations();
  },
  data() {
    return {
      canEditModule: userHasPermission('EstConf2'),
      canEditPreferences: userHasPermission('EstConf3'),
      clinic: getCurrentClinic(),
      selectedFields: {},
      form: {},
      categories: [],
    }
  },
  methods: {
    getWarehouseConfigurations() {
      const isLoading = this.$loading.show();
      this.api.getWarehouseConfigurations(this.clinic.id)
      .then(res => {
        this.form = res.data;
      })
      .catch(err => this.$toast.error(err.message))
      .finally(() => isLoading.hide());
    },
    updateCostConfiguration(props) {
      if(Object.keys(props)[0] === "update_cost_last_receipt"){
        this.form.update_cost_if_greater = false
        this.updateWarehouseConfigurations({update_cost_if_greater: false})
      } 
      
      if(Object.keys(props)[0] === "update_cost_if_greater"){
        this.form.update_cost_last_receipt = false
        this.updateWarehouseConfigurations({update_cost_last_receipt: false})
      }

      this.updateWarehouseConfigurations(props);
    },
    updateSalePriceConfiguration(props) {
      if(Object.keys(props)[0] === "update_sale_price_last_receipt"){
        this.form.update_sale_price_if_greater = false
        this.updateWarehouseConfigurations({update_sale_price_if_greater: false})
      }

      if(Object.keys(props)[0] === "update_sale_price_if_greater"){
        this.form.update_sale_price_last_receipt = false
        this.updateWarehouseConfigurations({update_sale_price_last_receipt: false})
      }

      this.updateWarehouseConfigurations(props);
    },
    updateWarehouseConfigurations(props) {
      this.api.updateWarehouseConfigurations(this.form.id, props)
      .then(() => {
        this.$toast.success('Configuração atualizada com sucesso.');
      })
      .catch(err => this.$toast.error(err.message));
    },
  },
}
</script>
<style lang="scss" scoped>
.ds-container {
    padding: 30px 10px;

    .ds-header {
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      margin: 35px 0px 10px 0px;
    }

    .ds-title {
      display: inline-flex;
      align-items: center;
      font-family: 'Red Hat Display';
      font-weight: 500;
      font-size: 18px;
    }

    .nav-link {
      font-size: 14px;
      margin: 2px 3px;
      padding: 0 10px;
      border: 1px solid #D9DFF2;
      border-radius: 100px;
      cursor: pointer;
      color: var(--type-active);

      &.active {
        background-color: #F4F5FB;
      }
    }

    .table {
      border: solid #C6CEEB 1px;
      -webkit-border-radius: 10px;
      -moz-border-radius: 10px;
      border-radius: 10px;

      thead {
        th {
          background: #F4F5FB;
          color: #525C7A;
        }
      }
      tbody {
        td {
          padding: 0.35rem;
          vertical-align: middle;
          color: #525C7A;
          height: 45px;
        }
      }
    }

    .card {
      margin: 10px 0px;
      margin-bottom: -1px;
      padding: 0px;

      .card-header {
        padding: 8px;
        margin: 0px;
        height: 40px;
        font-size: 16px;
        font-weight: 600;
        line-height: 24px;
        text-align: left;
        color: #0C1D59;

        .default {
          color: #8696AC;
          font-size: 12px;
        }

        .icon {
          width: 20px;
          height: 20px;
          cursor: pointer;

          &.trash {
            width: 20px;
            height: 20px;
            fill: none;
            stroke: var(--states-red-soft);
          }

          &.trash:hover {
            stroke: var(--states-error);
          }
        }

        .toolbar{
          float: right;
        }

        .chevron {
          height: 25px;
          width: 25px;
          float: right;
        }

        &.collapsed {
          .chevron {
            .down {
              display: block;
            }
            .up {
              display: none;
            }
          }
        }

        &.not-collapsed {
          .chevron {
            .down {
              display: none;
            }
            .up {
              display: block;
            }
          }
        }
        

      }

      .card-body{
        margin: 0px;
        padding: 0px 15px;

        .title{
          margin: 5px;
        }
      }
    }

}
.card {
  border: 1px solid var(--neutral-200);
  border-radius: 8px;
  padding: 20px;
  text-align: left;
  margin: 20px 0;

  .form-control {
    border: none !important;

    .form-check{

      input[type="checkbox"] {
        width: 16px;
        height: 16px;
      }
    }

  }
  
}
.card-title {
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 20px;
  color: var(--dark-blue);
}
.option {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.togle-button {
  margin-left: 10px;
}
</style>
